import { CardType } from 'components/Card';

import { stringToCategoryTag } from 'utils/stringToCategoryTag';

const getFiltered = (allItems: CardType[], selectedFilters: string[]) => {
  const allTags: string[] = [];

  const filtered = allItems.reduce(
    (categories: { items: CardType[]; allArticlesTags: string[] }, card: CardType) => {
      const tagsNames = card.tags?.map(({ name }: PageContent.TagsType) =>
        stringToCategoryTag(name)
      );

      const selectedCategoriesIncludedTags = selectedFilters.every((filter: string) =>
        tagsNames?.includes(filter)
      );

      if (selectedCategoriesIncludedTags) {
        categories.items.push(card);
        card.tags?.map(({ name }: PageContent.TagsType) => allTags.push(stringToCategoryTag(name)));
      }

      return categories;
    },
    { items: [], allArticlesTags: [] }
  );

  filtered.allArticlesTags.push(...new Set(allTags));

  return filtered;
};

export default getFiltered;
